import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import * as Types from 'types'
import { selectors as globalSelectors } from 'global-reducer'
import { selectors as globalPartnerSelectors } from 'partner-portal-reducer'
import { Spinner } from 'lp-components'
import { SectionBlock, PortalHeader, ProfileCompletionBar } from 'components'
import { PARTNER_PORTAL_ROUTE } from 'config'
import {
  useCommunity,
  isTeachingArtistEnabled,
  getCurrentCommunity,
} from 'utils'
import {
  buildBarModel,
  buildProfileCompletionOptions,
} from './profile-completion-sections'

const community = getCurrentCommunity()

const propTypes = {
  children: PropTypes.node,
  activeSchoolYears: PropTypes.arrayOf(Types.schoolYear),
  currentSchoolYear: Types.schoolYear.isRequired,
  partner: Types.partner,
  profileCompletionBarOptions: PropTypes.object,
}

const defaultProps = {
  children: null,
  activeSchoolYears: null,
  partner: null,
  profileCompletionBarOptions: {},
}

function Layout({
  children,
  activeSchoolYears,
  currentSchoolYear,
  partner,
  profileCompletionBarOptions,
}) {
  const [, setBarVersion] = useState(0)

  useEffect(() => {
    const onProfileCompletionUpdated = () => {
      setBarVersion((prev) => prev + 1)
    }
    if (typeof window !== 'undefined') {
      window.addEventListener(
        'profile-completion-updated',
        onProfileCompletionUpdated
      )
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener(
          'profile-completion-updated',
          onProfileCompletionUpdated
        )
      }
    }
  }, [])

  const communityConfig = useCommunity()
  const {
    defaultBranding: { dashboardHeader },
    partnerProgramsEnabled,
    partnerProfileCompletionEnabled,
  } = communityConfig

  const links = [
    {
      name: 'Organization',
      path: PARTNER_PORTAL_ROUTE + '/profile/organization',
    },
    {
      name: 'School Partnerships',
      path: PARTNER_PORTAL_ROUTE + '/profile/partnerships',
    },
    {
      name: 'Contacts',
      path: PARTNER_PORTAL_ROUTE + '/profile/contacts',
    },
  ]

  if (isTeachingArtistEnabled(community)) {
    links.push({
      name: 'Associated Teaching Artist',
      path: PARTNER_PORTAL_ROUTE + '/profile/associated-teaching-artist',
    })
  }

  if (partnerProgramsEnabled) {
    links.splice(1, 0, {
      name: 'Programs',
      path: PARTNER_PORTAL_ROUTE + '/profile/programs',
    })
  }

  const hasLoaded = !!activeSchoolYears
  const showBar = partnerProfileCompletionEnabled && partner
  const barModel = showBar
    ? buildBarModel(partner, communityConfig, profileCompletionBarOptions)
    : null

  return (
    <div>
      <PortalHeader
        title={`${currentSchoolYear.number} artlook Map Profile`}
        backgroundImage={dashboardHeader}
        links={links}
      />
      <div className="content-block-container">
        {showBar && (
          <SectionBlock>
            <ProfileCompletionBar
              variant="tab-header"
              percent={barModel.percent}
              completedSections={barModel.completedSections}
              sections={barModel.sections}
            />
          </SectionBlock>
        )}
        {!hasLoaded ? <Spinner /> : <React.Fragment>{children}</React.Fragment>}
      </div>
    </div>
  )
}

Layout.propTypes = propTypes
Layout.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    activeSchoolYears: globalPartnerSelectors.orderedActiveSchoolYears(state),
    currentSchoolYear: globalSelectors.currentSchoolYear(state),
    partner: globalPartnerSelectors.partner(state),
    profileCompletionBarOptions: buildProfileCompletionOptions(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Layout)
